(function(){
  'use strict';
  var source=document.currentScript;
  var label=source&&source.dataset.videoLabel;
  var motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  function apply(){
    document.querySelectorAll('video').forEach(function(video){
      video.controls=true;
      video.removeAttribute('aria-hidden');
      video.removeAttribute('tabindex');
      if(!video.getAttribute('aria-label')&&label)video.setAttribute('aria-label',label);
      if(motion.matches){video.autoplay=false;video.removeAttribute('autoplay');video.pause();}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply,{once:true});else apply();
  motion.addEventListener('change',apply);
})();
